import { Theme } from '@mui/material/styles';
import deepmerge from '@mui/utils/deepmerge';

import { Brand } from '@newfold/tokens';

import { PaletteMode, ThemeByMode } from '../../themeDefault';
import { createAlertTheme } from '../v2/components/Alert';
import { createButtonTheme, createLinkTheme } from '../v2/components/Button';
import {
  createCardContentTheme,
  createCardHeaderTheme,
  createCardTheme,
} from '../v2/components/Card';
import createChipTheme from '../v2/components/Chip';
import createDialogTheme from '../v2/components/Dialog';
import {
  createAutocompleteTheme,
  createCheckboxTheme,
  createFormHelperTextTheme,
  createMenuItemTheme,
  createMenuTheme,
  createOutlinedInputTheme,
  createSelectTheme,
  createSwitchTheme,
  createTextFieldTheme,
} from '../v2/components/FormElements';
import { generatePortalPixelsPalette } from '../v2/palette';

const interFontFamily = '"Inter", "Open Sans", Helvetica, Arial, sans-serif';

export const createRevampComponentOverrides = (themeForComponents: Theme) => ({
  MuiButton: createButtonTheme(themeForComponents),
  MuiLink: createLinkTheme(themeForComponents),
  MuiCard: createCardTheme(themeForComponents),
  MuiCardHeader: createCardHeaderTheme(themeForComponents),
  MuiCardContent: createCardContentTheme(themeForComponents),
  MuiTextField: createTextFieldTheme(themeForComponents),
  MuiOutlinedInput: createOutlinedInputTheme(themeForComponents),
  MuiFormHelperText: createFormHelperTextTheme(themeForComponents),
  MuiSelect: createSelectTheme(themeForComponents),
  MuiAutocomplete: createAutocompleteTheme(themeForComponents),
  MuiMenuItem: createMenuItemTheme(themeForComponents),
  MuiMenu: createMenuTheme(themeForComponents),
  MuiCheckbox: createCheckboxTheme(themeForComponents),
  MuiSwitch: createSwitchTheme(themeForComponents),
  MuiAlert: createAlertTheme(themeForComponents),
  MuiChip: createChipTheme(themeForComponents),
  MuiDialog: createDialogTheme(themeForComponents),
});

export const createBluehostRevampTheme = (
  mode: PaletteMode = 'light',
  brand: Brand,
): Theme => {
  const baseTheme = ThemeByMode(mode, brand);
  const portalPixelsPalette = generatePortalPixelsPalette(mode, brand);
  const themeForComponents = deepmerge(baseTheme, {
    palette: portalPixelsPalette,
  });

  return deepmerge(baseTheme, {
    palette: portalPixelsPalette,
    typography: { fontFamily: interFontFamily },
    components: createRevampComponentOverrides(themeForComponents),
  });
};

export const getBluehostRevampGlobalStyles = (selector: string) => ({
  'main.hosting-wrapper': {
    fontFamily: `${interFontFamily} !important`,
  },
  [`#${selector}`]: {
    fontFamily: `${interFontFamily} !important`,
  },
  [`#${selector} *`]: {
    fontFamily: 'inherit !important',
  },
});
